import { redirectTypes } from '../types';

export const setRedirect = (url) => async (dispatch) => {
    dispatch({
        type: redirectTypes.REDIRECT,
        redirectTo: url,
    });
};

export const clearRedirect = () => async (dispatch) => {
    dispatch({
        type: redirectTypes.CLEAR,
    });
};
